import { LegaleIncaricato } from './legale-incaricato';
import { TariffaLegale } from './tariffa';
import { TipoFase } from './tipologiche/tipo-fase';

export class FondoOnere {
  id: string;
  tipoFase: TipoFase;
  anno: number | string;
  mese: number;
  importo: number | string;
  legaleIncaricato: LegaleIncaricato;
  nota: string;

  tariffa: TariffaLegale

  imponibile: number;
  speseGenerali: number;
  speseEsenti: number;
  altreSpese: number;
  maggiorazione: number;
  revisionata: boolean;

  // static fromTariffa(tariffa: TariffaLegale) {
  //   const fe = new FondoOnere();
  //   fe.tariffa = tariffa;
  //   fe.imponibile = tariffa.imponibile
  //   fe.speseGenerali = tariffa.speseGenerali
  //   fe.speseEsenti = tariffa.speseEsenti
  //   // fe.altreSpese= tariffa.altreSpese
  //   fe.maggiorazione = tariffa.maggiorazione
  //   fe.revisionata = tariffa.revisionata
  //   return fe;
  // }

}
